export interface AccountTreeNode {
  value: string
  label: string
  code?: string
  children?: AccountTreeNode[]
  isCategory?: boolean
}

function nodeMatchesSearch(node: AccountTreeNode, searchLower: string): boolean {
  const label = node.label?.toLowerCase() || ''
  const code = node.code?.toLowerCase() || ''
  return label.includes(searchLower) || code.includes(searchLower)
}

export function filterAccountsTree<T extends AccountTreeNode>(nodes: T[], searchTerm: string): T[] {
  if (!searchTerm) return nodes

  const searchLower = searchTerm.toLowerCase()

  const filterNodes = (items: T[]): T[] => {
    return items.reduce((filtered: T[], node) => {
      const filteredChildren = node.children ? filterNodes(node.children as T[]) : []
      const selfMatches = nodeMatchesSearch(node, searchLower)

      if (selfMatches || filteredChildren.length > 0) {
        filtered.push({
          ...node,
          children: filteredChildren.length > 0 ? filteredChildren : undefined
        })
      }

      return filtered
    }, [])
  }

  return filterNodes(nodes)
}

export function collectTreeKeys(nodes: AccountTreeNode[]): string[] {
  const keys: string[] = []
  const walk = (items: AccountTreeNode[]) => {
    items.forEach((node) => {
      keys.push(node.value)
      if (node.children) walk(node.children)
    })
  }
  walk(nodes)
  return keys
}
